import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

import { InputText } from "primereact/inputtext";
import { Password } from 'primereact/password';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { InputOtp } from 'primereact/inputotp';
import { Toast } from 'primereact/toast';
import { checkConfirmPassword, checkEmail, checkPassword } from "../../Utils/Validator";
import { forgotPasswordOtpCheck, forgotPasswordRequestOtp, forgotPasswordReset } from "../../Api/SignupApi";
import { goToTop } from "../../Components/goToTop";
import { Slide, Zoom } from "react-awesome-reveal";

const ForgotPassword = () => {
    const toast = useRef<Toast>(null);
    const navigate = useNavigate();


    const [emailError, setEmailErrorMsg] = React.useState<string>('');
    const [showEmailCommonError, setShowEmailCommonError] = useState<boolean>(false);
    const [showEmailCommonErrorMsg, setShowEmailCommonErrorMsg] = React.useState<string>('');

    const [otpResult, setOTPResult] = useState<number>();

    const [showErrorPasswordCommon, setShowErrorPasswordCommon] = useState<boolean>(false);
    const [passwordCommonErrorMsg, setPasswordCommonErrorMsg] = React.useState<string>('');


    const [page, setPage] = useState<number>(1);
    const [loading, setLoading] = useState<boolean>(false);
    const [reSendLoading, setReSendLoading] = useState<boolean>(false);
    const [seconds, setSeconds] = useState<number>(0);
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
    const [showAlert, setShowAlert] = useState<boolean>(false);

    const [email, setEmail] = useState<string>('');
    const [otp, setOTP] = useState<string | number | undefined>();
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');

    const [showPasswordErrorMsg, setPasswordErrorMsg] = React.useState<string>('');
    const [showConfirmPasswordErrorMsg, setConfirmPasswordErrorMsg] = React.useState<string>('');

    // For showing password strength
    const header = <div className="font-bold mb-3">Password Strength</div>;
    const footer = (
        <React.Fragment>
            <Divider />
            <p className="mt-2">Suggestions</p>
            <ul className="pl-2 ml-2 mt-0 line-height-3">
                <li>At least one lowercase</li>
                <li>At least one uppercase</li>
                <li>At least one numeric</li>
                <li className="mb-0">Minimum 8 characters</li>
            </ul>
        </React.Fragment>
    );
    ////

    const goBack = () => {
        if (page === 2) {
            setPage(1);
            setOTP(undefined);
        } else if (page === 3) {
            setPage(2);
        }
        goToTop();
    }

    /* ******************************** OTP send ********************************************* */
    const handleSendOtp = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();

        setShowEmailCommonError(false)
        setShowEmailCommonErrorMsg('');

        if (checkOTPEmailCredential(email)) {
            setLoading(true);
            const data = await forgotPasswordRequestOtp(email);
            setLoading(false);

            if (data.status) {
                setOTPResult(data.body?.OTP || 0);
                localStorage.setItem('forgot_user_id', String(data.body?.user_id) || '');

                setPage(2);

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'OTP has been sent successfully, check your email inbox.',
                        life: 3000
                    });
                }

                /* **** resent OTP timer  ********/
                setSeconds(60);
                setIsButtonDisabled(true);
                /* **** resent OTP timer  ********/

                goToTop();
            } else {
                if (data.statusCode === 422) {
                    setShowEmailCommonError(true);
                    Object.entries(data.errors ?? []).map(([key, value], index) => (
                        setShowEmailCommonErrorMsg(value[0])
                    ))
                } else {
                    setShowEmailCommonError(true);
                    setShowEmailCommonErrorMsg(data.error || '');
                }
            }
        }
    }

    const checkOTPEmailCredential = (email: string): boolean => {
        const validEmail = checkEmail(email, true, setEmailErrorMsg);

        return validEmail;
    };
    /* ******************************** OTP send ********************************************* */

    const handleVerifyOTP = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        try {
            if (email && otp) {
                const result = await forgotPasswordOtpCheck(email, String(otp));

                if (result.otp_verified) {
                    setLoading(false);
                    setPage(3);

                    toast.current?.show({
                        severity: "success",
                        summary: "Success",
                        detail: "Your email has been successfully verified. You can now reset your password.",
                        life: 3000,
                    });

                    goToTop();
                } else {
                    setLoading(false);

                    toast.current?.show({
                        severity: "error",
                        summary: "Failed",
                        detail: result.massage || "Your OTP does not match",
                        life: 3000,
                    });

                    goToTop();
                }
            } else {
                setLoading(false);
                toast.current?.show({
                    severity: "warn",
                    summary: "Warning",
                    detail: "Please enter both email and OTP",
                    life: 3000,
                });
            }
        } catch (error: any) {
            setLoading(false);

            toast.current?.show({
                severity: "error",
                summary: "Error",
                detail: error?.message || "Something went wrong. Please try again.",
                life: 3000,
            });

            goToTop();
        }
    };


    useEffect(() => {
        if (seconds > 0) {
            const timerId = setTimeout(() => {
                setSeconds(seconds - 1);
            }, 1000);
            return () => clearTimeout(timerId);
        } else {
            setIsButtonDisabled(false);
        }
    }, [seconds]);

    const handleResendCode = async () => {

        setSeconds(60);
        setIsButtonDisabled(true);

        setReSendLoading(true);

        const data = await forgotPasswordRequestOtp(email);
        setReSendLoading(false);
        if (data.status) {
            setOTPResult(data.body?.OTP || 0);
            localStorage.setItem('forgot_user_id', String(data.body?.user_id) || '');

            if (toast.current) {
                toast.current.show({
                    severity: 'success',
                    summary: 'Success',
                    detail: 'OTP has been sent successfully, check your email inbox.',
                    life: 3000
                });
            }
        } else {
            setSeconds(0);
            setIsButtonDisabled(false);

            if (toast.current) {
                toast.current.show({
                    severity: 'error',
                    summary: 'Failed',
                    detail: 'OTP send failed',
                    life: 3000
                });
            }
        }
    };

    const handleResetPassword = async (e: { preventDefault: () => void; }) => {
        e.preventDefault();

        setShowErrorPasswordCommon(false);
        setPasswordCommonErrorMsg('');
        if (checkCredentials(password, confirmPassword)) {

            setLoading(true);
            const data = await forgotPasswordReset(localStorage.getItem('forgot_user_id') || '', password);
            setLoading(false);

            if (data.status) {
                setShowAlert(true);

                if (toast.current) {
                    toast.current.show({
                        severity: 'success',
                        summary: 'Success',
                        detail: 'New password add successfully!',
                        life: 3000
                    });
                }

                /* ***** remove local storage data  *******/
                if (localStorage.getItem('forgot_user_id')) {
                    localStorage.removeItem('forgot_user_id');
                }
                /* ***** remove local storage data  *******/

                setTimeout(() => {
                    setShowAlert(false);
                    navigate('/');
                }, 3000);

            } else {
                setShowErrorPasswordCommon(true);
                setPasswordCommonErrorMsg(data.error || '')
            }
        }
    }

    const handleCloseAlert = () => {
        setShowAlert(false);
    };

    function checkCredentials(password: string, confirmPassword: string): boolean {
        const isPasswordValid = checkPassword(password, true, setPasswordErrorMsg);
        const isConfirmPasswordValid = checkConfirmPassword(confirmPassword, password, true, setConfirmPasswordErrorMsg);

        return isPasswordValid && isConfirmPasswordValid;
    }

    return (
        <React.Fragment>
            <Toast ref={toast} />

            <section className="page_initial_section auth_init_section bg-white">
                <img src="/assets/images/page_dec_img.svg" className="page_dec_img" alt="" />
                <img src="/assets/images/page_dec_img.svg" className="page_dec_img image_2" alt="" />
                <div className="container-md">
                    <div className="row">
                        <div className="col-12 col-xl-7 col-lg-6 mx-auto my-auto sticky_top">
                            <Zoom triggerOnce>
                                <div className="page_image_area">
                                    <img src="/assets/images/traqdo_logo.svg" className="page_logo_img" alt="Traqdo" />
                                    <img src="/assets/images/page-image.svg" className="page_image" alt="Traqdo" />
                                </div>
                            </Zoom>
                        </div>

                        <div className="col-11 col-xl-5 col-lg-6 col-md-10 col-sm-10 mx-auto">
                            {page === 1 ? (
                                <Slide direction="up" triggerOnce>
                                    <article className="page_card h-100">
                                        <h2 className="page_card_head text-center">Reset password</h2>
                                        <p className="page_card_desc text-center">Enter you email to get the OTP</p>

                                        <form action="" className="page_form_area">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="custom_form_group">
                                                        <label htmlFor="email" className="custom_form_label">Email</label>
                                                        <InputText
                                                            id="email"
                                                            type="email"
                                                            value={email}
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setEmail(e.target.value)}
                                                            className="custom_form_input"
                                                            placeholder="johndeo@gmail.com"
                                                        />

                                                        {emailError &&
                                                            <small className="form_error_msg">{emailError}</small>
                                                        }

                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_group">
                                                        {showEmailCommonError &&
                                                            <small className="form_error_msg text-center">{showEmailCommonErrorMsg}</small>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_btn_area">
                                                        <Button
                                                            label={`${loading ? 'Processing' : 'SEND OTP'}`}
                                                            className="custom_form_btn letter_spaced w-100"
                                                            onClick={handleSendOtp}
                                                            loading={loading}
                                                            disabled={!email}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_bottom_area">
                                                        <p>Go back to&nbsp;
                                                            <Link to={'/auth/login'}>
                                                                Log in
                                                            </Link>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </article>
                                </Slide>
                            ) : page === 2 ? (
                                <Slide direction="up" triggerOnce>
                                    <article className="page_card h-100 top_button">
                                        <Button icon="bi bi-arrow-left"
                                            className="back_button"
                                            outlined
                                            aria-label="Back"
                                            onClick={goBack}
                                        />

                                        <h2 className="page_card_head text-center">Reset password</h2>
                                        <p className="page_card_desc text-center">Please check your email inbox for a 4 digit code</p>

                                        <form action="" className="page_form_area">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="custom_form_group">
                                                        <label htmlFor="email" className="custom_form_label text-center mb-4">Enter the OTP below</label>

                                                        <InputOtp
                                                            id="otp"
                                                            value={otp}
                                                            onChange={(e) => setOTP(e.value ?? undefined)}
                                                            integerOnly
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_btn_area">
                                                        <Button
                                                            label={`${reSendLoading ? "Processing" : loading ? "Verifying" : "VERIFY"}`}
                                                            className="custom_form_btn letter_spaced w-100"
                                                            onClick={handleVerifyOTP}
                                                            loading={loading}
                                                            disabled={!otp || String(otp)?.length < 4}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_bottom_area mb-4">
                                                        <p>Didn’t received the code?&nbsp;

                                                            <button
                                                                onClick={handleResendCode}
                                                                disabled={isButtonDisabled}
                                                            >
                                                                <span>Resend Code {isButtonDisabled && `in (${seconds}s)`}</span>
                                                            </button>
                                                        </p>
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_bottom_area">
                                                        <p>Go back to&nbsp;
                                                            <Link to={'/auth/login'}>
                                                                Log in
                                                            </Link>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </article>
                                </Slide>
                            ) : (
                                <Slide direction="up" triggerOnce>
                                    <article className="page_card h-100 top_button">
                                        <Button icon="bi bi-arrow-left"
                                            className="back_button"
                                            outlined
                                            aria-label="Back"
                                            onClick={goBack}
                                        />

                                        <h2 className="page_card_head text-center">Add a new password</h2>
                                        <p className="page_card_desc text-center">Enter new password to secure your account</p>

                                        <form action="" className="page_form_area">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="custom_form_group">
                                                        <label htmlFor="passwrord" className="custom_form_label">New Password</label>
                                                        <Password
                                                            value={password}
                                                            inputId="password"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setPassword(e.target.value)}
                                                            header={header}
                                                            footer={footer}
                                                            toggleMask
                                                            tabIndex={1}
                                                            className="custom_form_input w-100"
                                                            placeholder="***********"
                                                        />

                                                        {showPasswordErrorMsg &&
                                                            <small className="form_error_msg">{showPasswordErrorMsg}</small>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_group">
                                                        <label htmlFor="confirmPasswrord" className="custom_form_label">Confirm new password</label>
                                                        <Password
                                                            value={confirmPassword}
                                                            inputId="confirmPasswrord"
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => setConfirmPassword(e.target.value)}
                                                            feedback={false}
                                                            toggleMask
                                                            tabIndex={1}
                                                            className="custom_form_input w-100"
                                                            placeholder="***********"
                                                        />

                                                        {showConfirmPasswordErrorMsg &&
                                                            <small className="form_error_msg">{showConfirmPasswordErrorMsg}</small>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_group">
                                                        {showErrorPasswordCommon &&
                                                            <small className="form_error_msg text-center">{passwordCommonErrorMsg}</small>
                                                        }
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_btn_area">
                                                        <Button
                                                            label={`${loading ? 'Processing' : 'RESET'}`}
                                                            className="custom_form_btn letter_spaced w-100"
                                                            loading={loading}
                                                            onClick={handleResetPassword}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-12">
                                                    <div className="custom_form_bottom_area">
                                                        <p>Go back to&nbsp;
                                                            <Link to={'/'}>
                                                                Log in
                                                            </Link>
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </article>
                                </Slide>
                            )}
                        </div>
                    </div>
                </div>
            </section>

            {/* Show success message */}
            <div className={`message_backdrop ${showAlert ? 'show' : ''}`} onClick={handleCloseAlert}>
                <div className={`message_box ${showAlert ? 'show' : ''}`} onClick={e => e.stopPropagation()}>
                    <div className="message_box_content">
                        <i className="bi bi-check-circle-fill message_box_icon"></i>
                        <h6 className="message_box_message">
                            Password reset successfully.
                        </h6>
                    </div>
                </div>
            </div>
            {/*  */}
        </React.Fragment>
    )
}

export default ForgotPassword;